import { CARDINAL_URL, BASE_API_URL } from "../../constants/api-path.c";
import { SERVER_ERROR_PAGE } from "../../constants/path.c";
import Api from "../../utils/Api";

export const cardinal3ds = (
  slug: string,
  setSessionID: any,
  setJwt: any,
  navigate: any
) => {
  window.addEventListener(
    "message",
    function (event) {
      //This is a Cardinal Commerce URL in live.
      if (event.origin !== CARDINAL_URL) return;
      if (typeof event.data !== "string") return;
      // Cardinal sends non-JSON lifecycle pings on this origin alongside the
      // real Status payload — guard the parse so a stray ping doesn't throw.
      let data: any;
      try {
        data = JSON.parse(event.data);
      } catch {
        return;
      }
      if (data?.Status) {
        setSessionID(data.SessionId);
      }
    },
    false
  );

  Api()
    .post(`${BASE_API_URL}/threeds/jwt/create`, { URLKey: slug })
    .then((result) => {
      setJwt(result.jwt);
    })
    .catch(() => {
      navigate(`/${SERVER_ERROR_PAGE}`);
    });
};
